import React from 'react';
import { Form, Button } from 'react-bootstrap';
import { COLOR_WHITE, LINEAR_GRADIENT_BG } from '../../const';
import { ReactIcons } from '../../icons';
import useWindowDimensions from '../../helper/windowDimensions';
import { normalizeLanguageCode } from '../../helper/i18n';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

export default function LanguageSetting() {
    // states
    const { height, width } = useWindowDimensions();
    const [selectedLanguage, setSelectedLanguage] = React.useState("lao");

    const { t, i18n } = useTranslation();

    React.useEffect(() => {
        let storedLanguage;
        try {
            storedLanguage = localStorage.getItem("i18nextLng");
        } catch (error) {
            storedLanguage = undefined;
        }

        const normalized =
            normalizeLanguageCode(storedLanguage) ||
            normalizeLanguageCode(i18n.resolvedLanguage || i18n.language) ||
            "lao";
        setSelectedLanguage(normalized);
    }, [i18n.language, i18n.resolvedLanguage])

    // handle change language
    const handleChangeLanguage = async () => {
        const nextLanguage = normalizeLanguageCode(selectedLanguage) || "lao";
        i18n.changeLanguage(nextLanguage);
        setSelectedLanguage(nextLanguage);
        await Swal.fire({
            position: "center",
            icon: "success",
            title: t("success_notic"),
            showConfirmButton: false,
            timer: 1500
        });
    };

    // convert language name
    const convertLanguageName = (name) => {
        const normalized = normalizeLanguageCode(name) || "lao";
        switch (normalized) {
            case 'lao':
                return 'ພາສາລາວ';
            case 'en':
                return 'English';
            case 'chi':
                return '晉語';
            default:
                return 'ພາສາລາວ';
        }
    };

    return (
        <div className='p-4 w-full d-flex justify-content-center'>
            <div className={`${width > 700 ? 'w-50' : 'w-100'} border p-4 bg-white`}>
                <h5>{t("setting_lgg_title")}</h5>
                <br />
                <p>Default: {convertLanguageName(selectedLanguage)}</p>
                <hr />
                <div>
                    {languageTypes.map((item, index) => (
                        <div key={index} className='p-2 d-flex justify-content-between align-items-center'>
                            <div className='d-flex gap-2 justify-content-center align-items-start'>
                                <img src={item?.flag} alt={`${item?.title} flag`} style={{ width: 40, height: 25 }} />
                                <p>{item?.title}</p>
                            </div>
                            <Form.Check
                                type='radio'
                                name='language'
                                checked={selectedLanguage === item.name}
                                onChange={() => setSelectedLanguage(item.name)}
                                style={{ transform: 'scale(1.5)' }}
                            />
                        </div>
                    ))}
                </div>
                <br />
                <div className='mt-4 d-flex justify-content-end'>
                    <Button
                        variant='light'
                        style={{ background: LINEAR_GRADIENT_BG, color: COLOR_WHITE, border: 'none' }}
                        onClick={handleChangeLanguage}
                    >
                        <ReactIcons.FaCheck /> &nbsp; {t("save_button")}
                    </Button>
                </div>
            </div>
        </div>
    );
}

export const languageTypes = [
    {
        name: 'lao',
        flag: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Flag_of_Laos.svg/1200px-Flag_of_Laos.svg.png',
        title: 'ພາສາລາວ'
    },
    {
        name: 'en',
        flag: 'https://cdn.britannica.com/33/4833-050-F6E415FE/Flag-United-States-of-America.jpg',
        title: 'English'
    },
    {
        name: 'chi',
        flag: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTf8sgzYo_8TbQaBP8zKOwVe7E0k8hWk98onA&s',
        title: '晉語'
    }
];
